import { differentLocales } from '@abp/ng.core';
import { defaultLocalErrorHandlerFn, LocaleErrorHandlerData } from '@abp/ng.core/locale';

export interface RegisterLocaleData {
  cultureNameLocaleFileMap: Record<string, string>;
  errorHandlerFn: (data: LocaleErrorHandlerData) => any;
}

export function registerLocale({
  cultureNameLocaleFileMap = {},
  errorHandlerFn = defaultLocalErrorHandlerFn,
}: Partial<RegisterLocaleData> = {}) {
  return (locale: string): Promise<any> => {
    const localeMap = { ...differentLocales, ...cultureNameLocaleFileMap };
    const localePath = `/locales/${localeMap[locale] || locale}`;

    return new Promise((resolve, reject) => {
      return import(
        /* webpackChunkName: "_locale-[request]" */
        /* webpackInclude: /[/\\]locales[/\\][^/\\]+\.(mjs|js)$/ */
        /* webpackExclude: /[/\\](global|extra)|\.js\.map$/ */
        `@angular/common${localePath}`
      )
        .then(value => {
          let module: any = value;

          while (module.default) {
            module = module.default;
          }

          resolve({ default: module });
        })
        .catch(error => {
          errorHandlerFn({
            resolve,
            reject,
            error,
            locale,
          });
        });
    });
  };
}
